import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  saveToGlobalState,
  getStoredData,
  removeSpecificData,
} from "../../utils/localStorage";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const API_URL = process.env.REACT_APP_API_URL;

export default function GoogleLoginButton() {
  const navigate = useNavigate();
  const buttonRef = useRef(null);

  const { accessToken, setShowLoginModal, setUser, setAccessToken } = useAuth();

  const dataStorage = getStoredData();

  useEffect(() => {
    const loadGoogleScript = () => {
      return new Promise((resolve) => {
        if (
          window.google &&
          window.google.accounts &&
          window.google.accounts.id
        ) {
          resolve();
          return;
        }

        const existingScript = document.getElementById(
          "google-identity-script",
        );

        if (existingScript) {
          existingScript.onload = resolve;
          return;
        }

        const script = document.createElement("script");

        script.src = "https://accounts.google.com/gsi/client";

        script.async = true;
        script.defer = true;

        script.id = "google-identity-script";

        script.onload = resolve;

        document.body.appendChild(script);
      });
    };

    const initializeGoogle = async () => {
      await loadGoogleScript();

      if (
        !window.google ||
        !window.google.accounts ||
        !window.google.accounts.id
      ) {
        console.error("Google Identity não carregou");
        return;
      }

      if (!buttonRef.current) return;

      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        use_fedcm_for_prompt: true,

        callback: async (response) => {
          console.log("LOGIN GOOGLE:");
          console.log(response);

          try {
            const res = await fetch(`${API_URL}/api/auth/google/`, {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                credential: response.credential,
              }),
            });

            const data = await res.json();

            console.log("BACKEND RESPONSE:", data);

            if (res.ok) {
              setAccessToken(data.access);
              setUser(data.user);
              setShowLoginModal(false);

              if (dataStorage?.tab_login == "CLIENTE") {
                navigate("/dashboard-client");
                return;
              } else if (dataStorage?.tab_login == "VIAJANTE") {
                navigate("/dashboard-traveler");
                return;
              } else if (dataStorage?.tab_login == "DESTINATÁRIO") {
                navigate("/dashboard-receiver");
                return;
              } else if (dataStorage?.tab_login == "MALA") {
                navigate("/qual-meio-transporte");
                return;
              } else if (dataStorage?.tab_login == "COMPRAR") {
                console.log(dataStorage);
                console.log(dataStorage?.payload);
                if (dataStorage?.payload) {
                  const response = await fetch(
                    `${API_URL}/api/create-trip-negotiations/`,
                    {
                      method: "POST",
                      credentials: "include",
                      headers: {
                        "Content-Type": "application/json",
                        ...(data.access
                          ? { Authorization: `Bearer ${data.access}` }
                          : {}),
                      },
                      body: JSON.stringify(dataStorage?.payload),
                    },
                  );
                }

                removeSpecificData("payload");
                navigate("/dashboard-client");
                return;
              }

              navigate("/dashboard-client");

              return;
            }

            if (data.redirect === "cadastro_google") {
              localStorage.setItem(
                "google_prefill",
                JSON.stringify(data.prefill),
              );
              navigate("/cadastro", {
                state: {
                  ...data.prefill,
                  google_incompleto: true,
                },
              });
              return;
            }

            if (data.redirect === "confirmacao_email") {
              saveToGlobalState({
                confirmation_token: data.confirmation_token,
              });
              setShowLoginModal(false);
              navigate("/confirmacao-email", {
                state: {
                  email: data.email,
                  telefone: data.telefone,
                  phone_confirmation: data.phone_confirmation,
                },
              });
              return;
            }

            if (data.redirect === "confirmacao_telefone") {
              saveToGlobalState({
                confirmation_token: data.confirmation_token,
              });
              setShowLoginModal(false);
              navigate("/confirmacao-telefone", {
                state: { telefone: data.telefone },
              });
              return;
            }

            if (!response.ok) {
              alert(data.detail || "Erro ao fazer login com Google");
              return;
            }
            console.log("Erro login Google:", data);
          } catch (err) {
            console.error("Erro no login Google:", err);
          }
        },
      });

      buttonRef.current.innerHTML = "";

      window.google.accounts.id.renderButton(buttonRef.current, {
        theme: "outline",
        size: "large",
        text: "continue_with",
        shape: "pill",
        width: buttonRef.current.offsetWidth,
      });
    };

    initializeGoogle();
  }, [navigate, setShowLoginModal, setUser, setAccessToken]);

  return <div ref={buttonRef} className="google-container" />;
}
